import { AppFeature } from 'src/app/core/app-feature/app-feature';
import { DefMM13 } from '../../masterdata/models/config-version/DefMM13';
import { DefMM13Element } from '../../masterdata/models/config-version/DefMM13Element';
import { Criterion } from '../models/criterions/Criterion';
import { saveAnalysisInCacheAndRouteTo, saveTemplateInCacheAndRouteTo } from '../state/analysis.actions';

export class AngularJSUtils {
    public static readonly ANALYSIS = '/analysis';
    public static readonly SINGLE = '/single';
    public static readonly GROUP = '/group';
    public static readonly FREE = '////FREE/';
    public static readonly HEADER = '////header';
    public static readonly OVERVIEW = '////navigation';
    public static readonly CARDINAL = '/#';
    public static readonly PROBLEM = '////problem/';
    public static readonly ATTACHMENT = '////attachment';
    public static readonly CRITERION = '////criterion';
    public static readonly TEMPLATE_HEADER = '/header';
    public static readonly TEMPLATE_PROBLEM = '/problem';
    public static readonly TEMPLATE_OVERVIEW = '/navigation';
    public static readonly TEMPLATE_CRITERION = '/criterion';
    public static readonly migratedCriteria: Criterion[] = [Criterion.MM12, Criterion.MM13];

    public static buildTreeFunc = (defConfigVersion: DefMM13): DefMM13Element[] => {
        const mainGroup: DefMM13Element[] = [];
        const subGroup: DefMM13Element[] = [];
        const hazardElement: DefMM13Element[] = [];

        defConfigVersion.elements.map(item => {
            if (item.mainGroup !== null && item.subGroup === null && item.hazardElement === null) {
                mainGroup.push(item);
            } else if (item.mainGroup !== null && item.subGroup !== null && item.hazardElement === null) {
                subGroup.push(item);
            } else {
                hazardElement.push(item);
            }
        });

        mainGroup.sort((a, b) => (a.mainGroup! < b.mainGroup! ? -1 : 1));
        subGroup.sort((a, b) => (a.subGroup! < b.subGroup! ? -1 : 1));
        hazardElement.sort((a, b) => (a.hazardElement! < b.hazardElement! ? -1 : 1));
        subGroup.map(item => {
            item.allChildDefMM13ElementId = [item.id];
            hazardElement.map(hazardEl => {
                hazardEl.allChildDefMM13ElementId = [hazardEl.id];
                if (item.mainGroup === hazardEl.mainGroup && item.subGroup === hazardEl.subGroup) {
                    item.childDefMM13Element.push({ ...hazardEl });
                    item.allChildDefMM13ElementId = [...(item.allChildDefMM13ElementId ?? []), hazardEl.id];
                }
            });
            return item;
        });
        mainGroup.map(item => {
            item.allChildDefMM13ElementId = [item.id];
            subGroup.map(subGr => {
                if (item.mainGroup === subGr.mainGroup) {
                    item.childDefMM13Element.push(subGr);
                    item.allChildDefMM13ElementId = [...(item.allChildDefMM13ElementId ?? []), ...(subGr.allChildDefMM13ElementId ?? [])];
                }
            });
        });
        return mainGroup;
    };

    public static getCriterionUrl(criterion: Criterion | null, isTemplate: boolean): string {
        return isTemplate ? AngularJSUtils.TEMPLATE_CRITERION + criterion : AngularJSUtils.CRITERION + criterion;
    }

    public static getAngularJSRouting(route: string, isTemplate: boolean, param: Criterion | null) {
        switch (route) {
            case 'HEADER': {
                return isTemplate
                    ? saveTemplateInCacheAndRouteTo({ redirectUrl: AngularJSUtils.TEMPLATE_HEADER })
                    : saveAnalysisInCacheAndRouteTo({ redirectUrl: AngularJSUtils.HEADER });
            }
            case 'PROBLEM': {
                return isTemplate
                    ? saveTemplateInCacheAndRouteTo({ redirectUrl: AngularJSUtils.TEMPLATE_PROBLEM })
                    : saveAnalysisInCacheAndRouteTo({ redirectUrl: AngularJSUtils.PROBLEM });
            }
            case 'OVERVIEW': {
                return isTemplate
                    ? saveTemplateInCacheAndRouteTo({ redirectUrl: AngularJSUtils.TEMPLATE_OVERVIEW })
                    : saveAnalysisInCacheAndRouteTo({ redirectUrl: AngularJSUtils.OVERVIEW });
            }
            case 'CRITERION': {
                return isTemplate
                    ? saveTemplateInCacheAndRouteTo({
                          redirectUrl: AngularJSUtils.getCriterionUrl(param, true)
                      })
                    : saveAnalysisInCacheAndRouteTo({
                          redirectUrl: AngularJSUtils.getCriterionUrl(param, false)
                      });
            }
            default:
                return isTemplate
                    ? saveTemplateInCacheAndRouteTo({ redirectUrl: AngularJSUtils.TEMPLATE_HEADER })
                    : saveAnalysisInCacheAndRouteTo({ redirectUrl: AngularJSUtils.HEADER });
        }
    }

    public static isMigratedCriterion(criterion: Criterion): boolean {
        return this.migratedCriteria.includes(criterion);
    }

    static isMigratedCriteriaEnabled(criterion: Criterion, appFeatures: AppFeature[] | null) {
        return !!appFeatures?.some(item => item.featureKey === 'CR' + criterion && item.enabled);
    }

    static isMigratedAnalysisPage(page: string, appFeatures: AppFeature[] | null) {
        return !!appFeatures?.find(item => page.toLowerCase() === item.featureKey.toLowerCase() && item.enabled);
    }
}
